import { gql } from "graphql-tag";

export const GET_PROBLEM_CATEGORIES = gql`
  query GetProblemCategories($pagination: PaginationInput, $filter: ProblemCategoryFilterInput) {
    problemCategories(pagination: $pagination, filter: $filter) {
      data {
        id
        name
        description
        accountId
        isActive
        problemCategoryQueues {
          id
          problemCategoryId
          queueId
          queue {
            id
            name
            description
          }
        }
        problemCategoryAssetModels {
          id
          problemCategoryId
          assetModelId
          assetModel {
            id
            name
            description
            manufacturer
          }
        }
        queueCount
        assetModelCount
        queueNames
        assetModelNames
        createdAt
        updatedAt
      }
      meta {
        page
        limit
        total
        totalPages
        hasNext
        hasPrev
      }
    }
  }
`;

export const GET_PROBLEM_CATEGORY = gql`
  query GetProblemCategory($id: ID!) {
    problemCategory(id: $id) {
      id
      name
      description
      accountId
      isActive
      problemCategoryQueues {
        id
        problemCategoryId
        queueId
        queue {
          id
          name
          description
        }
      }
      problemCategoryAssetModels {
        id
        problemCategoryId
        assetModelId
        assetModel {
          id
          name
          description
          manufacturer
        }
      }
      queueCount
      assetModelCount
      queueNames
      assetModelNames
      createdAt
      updatedAt
    }
  }
`;
